
//1、验证手机号
//2、验证邮箱
//3、时间戳转时间(timestamp,timeType):  timeType:date、y-m、time、datetime,默认datetime
//4、时间转时间戳(datetime):	//datetime:2020-08-08 19:30:00
//5、获取当前时间戳
//6、判断是否在微信中打开的
//7、获取手机系统语言(暂时只提供八种语言)
//8、判断手机系统:	//系统类型(IOS:ios/安卓:android/电脑:pc)
//9、随机打乱数组(arr)
//10、随机生成字符串(len)
//11、监听图片全部预加载完成(images,cbOk)

export default {
	//1、验证手机号
	phoneRegFn(phone){
	    const myreg = /^1[0-9]{10}$/;
		return myreg.test(phone);
	},
	
	//2、验证邮箱
	emailRegFn(email){
	  var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
	  return reg.test(email)
	},
	
	//3、时间戳转时间
	getDate(timestamp,timeType){
		function add0(m){ return m < 10 ? '0' + m : m };
		var time = new Date(timestamp);
		var y = time.getFullYear();
		var m = time.getMonth() + 1;
		var d = time.getDate();
		var h = time.getHours();
		var mm = time.getMinutes();
		var s = time.getSeconds();
		var datetimeText = ''
		switch(timeType){
			case 'date':	//只获取日期
				datetimeText =  y + '-' + add0(m) + '-' + add0(d)
				break;
				
			case 'y-m':		//只获取年月
				datetimeText =  y + '-' + add0(m)
				break;
				
			case 'time':	//只获取时间
				datetimeText =  add0(h) + ':' + add0(mm) + ':' + add0(s)
				break;
				
			default:		//默认获取完整的日期时间
				datetimeText = y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
				break;
		}
		return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
	},
	
	//4、时间转时间戳
	getTimes(datetime){	//datetime:2020-08-08 19:30:00
	  var date = new Date(datetime.replace(/-/g, '/'));
	  return date.getTime();
	},
	
	//5、获取当前时间戳
	getNowTimes(){
		var timestamp = (new Date()).getTime()
		return timestamp
	},
	
	
	//6、判断是否在微信中打开的
	isWeixin(){
	   	var ua = navigator.userAgent.toLowerCase();
		return ua.match(/MicroMessenger/i)=="micromessenger"
	},
	
	//7、获取手机系统语言(暂时只提供八种语言)
	getSystemLang(){
		var language = (navigator.appName == 'Netscape') ? navigator.language : navigator.browserLanguage;
		language = language?language:'en';
		var result;
		if(language.indexOf('zh') > -1){result = 'zh';}			//中国
		else if(language.indexOf('ar') > -1){result = 'ar';}	//阿拉伯
		else if(language.indexOf('ja') > -1){result = 'ja';}	//日本
		else if(language.indexOf('ko') > -1){result = 'ko';}	//韩国
		else if(language.indexOf('de') > -1){result = 'de';}	//德国
		else if(language.indexOf('es') > -1){result = 'es';}	//西班牙
		else if(language.indexOf('fr') > -1){result = 'fr';}	//法国
		else if(language.indexOf('ru') > -1){result = 'ru';}	//俄罗斯
		else{ result = 'en' }	//其他语音一个一个列出来
		return result;
	},
	
	//8、判断手机系统
	system(){	//系统类型(IOS:ios/安卓:android/电脑:pc)
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
		var result = ''
		if(isAndroid){ result = 'android' }
		else if(isiOS){ result = 'ios' }
		else{ result = 'pc'}
		return result
	},
	
	//9、随机打乱数组
	randomArray(arr) {
	　　for(var i = arr.length - 1; i >= 0; i--) {
	　　　　var randomIndex = Math.floor(Math.random() * (i + 1));
	　　　　var itemAtIndex = arr[randomIndex];
	　　　　arr[randomIndex] = arr[i];
	　　　　arr[i] = itemAtIndex;
	　　}
	　　return arr
	},
	
	//10、随机生成字符串
	randomString(len) {
		len = len || 32;
		var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
		var maxPos = $chars.length;
		var pwd = '';
			for (var i = 0; i < len; i++) {
			pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
		}
		return pwd;
	},
	
	//11、监听图片全部预加载完成
	loadImages(images,cbOk){
		var loadImgs = []
		var imgLen = images.length
		var imgIndex = 0
		images.forEach((item,i)=>{
			loadImgs[i] = new Image();
			loadImgs[i].onload = function(){
				imgIndex++
				cbOk && cbOk(imgIndex,imgLen)
			}
			loadImgs[i].src = item
		})
	},
	
	//判断是否移动端
	isMobile(){
		var isMobile = (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))?true:false
		return isMobile
	},
	
	removeHTMLTag(str) {
	   str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
	   str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
	   str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
	   str = str.replace(/ /ig, '') // 去掉
	   const arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' } // 转义符换成普通字符
	   str = str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all, t) { return arrEntities[t] })
	   return str
	 }

	
}


// WEBPACK FOOTER //
// ./src/static/js/common.js